import { render, staticRenderFns } from "./editSpeedTable.vue?vue&type=template&id=af3adf24"
import script from "./editSpeedTable.vue?vue&type=script&lang=js"
export * from "./editSpeedTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports